import React from "react";
import { formatInUserTimezone } from "../../utils/timezone";

function NextActivityCell({ activity, onAdd, onComplete, onSuspend }) {
  if (!activity) {
    return (
      <button
        type="button"
        className="next-activity-empty-btn"
        onClick={onAdd}
        title="Add Next Contact"
      >
        <i className="fas fa-plus" />
        <span className="next-activity-empty-label">Add Next Contact</span>
      </button>
    );
  }

  const isOverdue = activity.status === "Overdue";
  const statusClass = isOverdue
    ? "next-activity-status next-activity-status-overdue"
    : "next-activity-status next-activity-status-active";

  /* Rich hover tooltip so the user can recover any truncated text. */
  const fullDate = formatInUserTimezone(activity.planned_date);
  const hoverTitle = [
    activity.activity_type || "",
    isOverdue ? "OVERDUE" : "Active",
    `Planned: ${fullDate}`,
    activity.notes ? `Notes: ${activity.notes}` : null,
    activity.status_updated_at
      ? `Updated: ${formatInUserTimezone(activity.status_updated_at)}`
      : null,
  ]
    .filter(Boolean)
    .join("\n");

  return (
    <div
      className={`next-activity-cell ${isOverdue ? "is-overdue" : ""}`}
      title={hoverTitle}
    >
      <div className="next-activity-cell-head">
        <span className={statusClass}>
          {isOverdue ? (
            <>
              <i className="fas fa-exclamation-triangle" /> Overdue
            </>
          ) : (
            <>
              <i className="fas fa-bullseye" /> Active
            </>
          )}
        </span>
        <span
          className="next-activity-type"
          title={activity.activity_type}
        >
          {activity.activity_type}
        </span>
      </div>

      <div className="next-activity-date" title={`Planned: ${fullDate}`}>
        {fullDate}
      </div>

      {activity.notes && (
        <div className="next-activity-notes" title={activity.notes}>
          {activity.notes}
        </div>
      )}

      <div className="next-activity-cell-actions">
        <button
          type="button"
          className="next-activity-action-btn"
          title="Mark done"
          onClick={onComplete}
        >
          <i className="fas fa-check" />
        </button>
        <button
          type="button"
          className="next-activity-action-btn"
          title="Suspend"
          onClick={onSuspend}
        >
          <i className="fas fa-pause" />
        </button>
      </div>
    </div>
  );
}

export default NextActivityCell;